import app from '../../forum/app';
import Component from '../../common/Component';
import username from '../../common/helpers/username';
import DiscussionControls from '../utils/DiscussionControls';
import ComposerPostPreview from './ComposerPostPreview';
import listItems from '../../common/helpers/listItems';
import Avatar from '../../common/components/Avatar';
/**
 * The `ReplyPlaceholder` component displays a placeholder for a reply, which,
 * when clicked, opens the reply composer.
 */
export default class ReplyPlaceholder extends Component {
  view() {
    const composingReply = this.attrs.composingReply ? this.attrs.composingReply() : app.composer.composingReplyTo(this.attrs.discussion);
    if (composingReply) {
      return m("article", {
        className: "Post CommentPost editing",
        "aria-busy": "true"
      }, m("div", {
        className: "Post-container"
      }, m("div", {
        className: "Post-side"
      }, m(Avatar, {
        user: app.session.user,
        className: "Post-avatar"
      })), m("div", {
        className: "Post-main"
      }, m("header", {
        className: "Post-header"
      }, m("div", {
        className: "PostUser"
      }, m("h3", {
        className: "PostUser-name"
      }, username(app.session.user)), m("ul", {
        className: "PostUser-badges badges badges--packed"
      }, listItems(app.session.user.badges().toArray())))), m("div", {
        className: "Post-body"
      }, m(ComposerPostPreview, {
        className: "Post-body",
        composer: app.composer,
        surround: this.anchorPreview.bind(this)
      })))));
    }
    const reply = this.attrs.onclick || (() => {
      DiscussionControls.replyAction.call(this.attrs.discussion, true, false).catch(() => {});
    });
    return m("button", {
      type: "button",
      className: "Post ReplyPlaceholder",
      onclick: reply
    }, m("div", {
      className: "Post-container"
    }, m("div", {
      className: "Post-side"
    }, m(Avatar, {
      user: app.session.user,
      className: "Post-avatar"
    })), m("div", {
      className: "Post-main"
    }, m("span", {
      className: "Post-header"
    }, app.translator.trans('core.forum.post_stream.reply_placeholder')))));
  }
  anchorPreview(preview) {
    const anchorToBottom = $(window).scrollTop() + $(window).height() >= $(document).height();
    preview();
    if (anchorToBottom) {
      $(window).scrollTop($(document).height());
    }
  }
}
flarum.reg.add('core', 'forum/components/ReplyPlaceholder', ReplyPlaceholder);